<template lang="pug">
b-navbar(type="dark" variant="kexa-nav" toggleable="md" class="fixed-top" v-if="isLoggedIn")
  b-container
    b-nav-toggle(target="navbar_collapse")
    b-navbar-brand
      router-link(:to="{ path: '/complaints' }")
        img(:src="logo", width='250', height='30', alt='')
    b-collapse#navbar_collapse(is-nav)
      b-navbar-nav.ml-auto(is-nav-bar)
        li.nav-item.b-nav-dropdown.dropdown
          router-link.nav-link(v-if="$isAllowed('viewAll')" ,:to="{ path: '/complaints/all' }" exact) Todos
        b-nav-item-dropdown(v-if="$isAllowed('manageUsers') || $isAllowed('viewAll')" text="Pendientes" right)
          b-dropdown-item(:to="{ path: '/complaints' }" exact) Recorrido
          b-dropdown-item(:to="{ path: '/complaints_ecommerce' }" exact) Ecommerce
        li.nav-item.b-nav-dropdown.dropdown
          router-link.nav-link(v-if="$isAllowed('createComplaint')" ,:to="{ path: '/complaints/new' }" exact) Registrar
        li.nav-item.b-nav-dropdown.dropdown
          router-link.nav-link(v-if="$isAllowed('createComplaint')" ,:to="{ path: '/complaints/pre-approved' }" exact) Nuevo pre-aprobado
        li.nav-item.b-nav-dropdown.dropdown
          router-link.nav-link(v-if="$isAllowed('manageOperators')" ,:to="{ path: '/operators' }" exact) Empresas
        li.nav-item.b-nav-dropdown.dropdown
          router-link.nav-link(v-if="$isAllowed('viewFinance')" ,:to="{ path: '/finance' }" exact) Finanzas
        b-nav-item-dropdown(v-if="$isAllowed('manageUsers')" text="Configuración" right)
          b-dropdown-item(:to="{ path: '/users' }" exact) Gestión de usuarios
          b-dropdown-item(:to="{ path: '/categories' }" exact) Gestión de categorías
        div.dropdown-divider
        b-nav-item-dropdown(:text="user" right)
          b-dropdown-item
            icon(name="sign-out")
            |
            router-link(:to="{ path: '/logout' }") Salir
</template>

<script>
import store from '@/store';
import complaintsPerimeter from '@/perimeters/complaintsPerimeter';
import constants from '@/constants/Status.constants';
import generalLogo from '@/assets/img/recorrido-logo-monochrome-white.svg';

export default {
  name: 'Header',
  perimeters: [complaintsPerimeter],
  data() {
    return {
      roles: constants.ROLES,
    };
  },
  computed: {
    isLoggedIn() {
      return store.state.isLogged;
    },
    user() {
      return `${this.roles[store.state.user.role].name} / ${store.state.user.name}`;
    },
    logo() {
      return generalLogo;
    },
  },
};
</script>

<style lang="scss">
.navbar-brand {
  &>a {
    color: #FFF;
  }
}

.navbar-dark .navbar-nav .nav-link {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Header.vue